export default "__VITE_ASSET__C6aYUB7U__"